"use client";

import { useLayoutEffect } from "react";
import { usePathname } from "next/navigation";

/**
 * Snaps the viewport to the top synchronously before the next paint whenever
 * the route changes. Gives the View-Transitions API a consistent origin so
 * the swoosh animation doesn't play on a half-scrolled page.
 *
 * Mirrors the pattern used in the reference scriptbee site.
 */
export function ScrollToTop() {
  const pathname = usePathname();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
